import type { FaireProductEntity } from "../../entity_types/product";

export const p_7r568xa26n: FaireProductEntity = {
  token: "p_7r568xa26n",
  type: "product",
  name: "KAF Home Plain Weave White Kitchen Towels - Set of 10",
  brandName: "KAF Home",
  imageUrl:
    "https://cdn.faire.com/fastly/605e7bc5af7f333b454bbd713562dcfde929102d208b0431257d2a195ddfb0c8.jpeg",
  priceDollars: 15,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/ce1f717516fae572af6a77ebde231a537ee118797e97df3cd3affda638ebf709.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
